import { AppContent } from '../AppContent';
import { MetaContentValues } from '../metaContentValues';

// id = YouTube video ID
const video = (title: string, id: string) => ({
  title: `Birmingham Midshires: ${title}`,
  id,
});

const rentersRightsBill: AppContent['rentersRightsBill'] = {
  backLabel: 'Back to Landlord support',
  metaContent: {
    title: MetaContentValues.rentersRightsBill.title,
  },
  title: 'The Renters Rights Bill: A Bitesize Regulation series',
  description:
    'This video series looks at all the regulation changes to the private rented sector (PRS).',
  videoLinks: [
    video('The Renters rights bill', 'xUNluOKGthM'),
    video('The Latest on Minimum Energy Efficiency Standards', '810LnuRCaMM'),
    video('An overview of the Renters Rights Bill.', 'GKpQgaEMlxA'),
    video("Order of Changes for the Renters' Rights Bill", 'qxNP5Jfrv-o'),
    video('Advertising a Property for Let', 'XBqEIkhp3b4'),
    video('The New Tenancy Structure', 'CFbEcd4ZGWc'),
    video('Rent in Advance', 'SzPEDwDLjbo'),
    video('The Potential Impact on Student Lets', 'GN2172OsqS0'),
    video(
      'The Potential Impact on Houses in Multiple Occupation',
      'gGwsuitmnxI',
    ),
    video('Abolition of section 21', 'SDnCMWOU8RU'),
    video('Possession without Section 21', 'r3SVMl9kkII'),
    video('Ending Tenancy Arrears', '8VQKewGu-zc'),
    video('Ending a Tenancy To Sell the Property', '1ZSYpboMVMY'),
    video('The Proposed PRS Database', 'fYHXFQHGSZM'),
    video('Decent Home Standard', 'H_WjZS1l5Ps'),
    video('Awaabs Law', 'vBZbdI6EDdU'),
    video('RRB When Things Go Wrong', '2fbZH2P9BC0'),
    video('Landlords To Prepare', 'Hywsqei3Txo'),
    video(
      "What do Landlords need to do on Commencement of the Renters' Rights Bill?",
      'eVIC1vv8al0',
    ),
    video('Finding More Information', '8hMMOn7Rbhw'),
    video('Future of PRS', 'WPapAEfHsGo'),
    video('Good News - Doing right by renters', 'H1qW-QX6SJo'),
  ],
};

export default rentersRightsBill;
